import { IRoute } from "@src/routes";
import ViewRefundProgram from "./pages/ListRefundPrograms";

const routes: IRoute[] = [
    {
        path: "/refund/refund-programs",
        key: "REFUND_CONFIGURATION_REFUND_PROGRAMS",
        exact: true,
        component: ViewRefundProgram,
    },
];

export default routes;